import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { environmentSelectors, pluginActions } from '@lifesize/nucleus';
import { openWhiteboardDesktop, openWhiteboardWebapp } from 'actions/Plugins';
import CollaborationTools from 'components/InCall/CollaborationTools';
import { FETCH_ERROR_TYPES } from 'constants/PluginConstants';
import { hooks } from '@lifesize/clients.sdk';

const mapStateToProps = (state, ownProps) => {
  const isDesktop = environmentSelectors.platform(state).isDesktop;

  return {
    dialString: _get(ownProps, 'call.dialString'),
    isDesktop,
    meetingUUID: _get(ownProps, 'conference.uuid')
  };
};

const mapDispatchToProps = (dispatch) => ({
  requestWhiteboard: (meetingUUID, cb) => {
    dispatch(pluginActions.fetchPluginHashCode(meetingUUID))
      .then((response) => {
        if (response) {
          cb({ data: response });
        } else {
          cb({ error: FETCH_ERROR_TYPES.NOT_SUPPORTED }); // meeting uuid not found, etc.
        }
      })
      .catch((err) => cb({ error: FETCH_ERROR_TYPES.SERVER })); // server error
  },
  desktopOpenWhiteboard: (url) => {
    dispatch(openWhiteboardDesktop(url));
  },
  webappOpenWhiteboard: (url) => {
    dispatch(openWhiteboardWebapp(url));
  }
});

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(CollaborationTools);

const FunctionalWrapper = (props) => {
  const conference = hooks.useConferenceInfo();
  const call = hooks.useCallState();

  return <ConnectedComponent conference={conference} call={call} {...props} />;
};

export default FunctionalWrapper;
